import { lazy, Suspense } from 'react';
import type { HighlightItem, HighlightTarget, PdfViewerProps } from './PdfViewerImpl';

// Lazy-load de l'implémentation : pdfjs (~300-400 KB gzip) reste hors du
// bundle d'entrée et n'est chargé qu'à l'ouverture d'un document.
const PdfViewerImpl = lazy(() => import('./PdfViewerImpl'));

export type { HighlightItem, HighlightTarget, PdfViewerProps };

export function PdfViewer(props: PdfViewerProps) {
  return (
    <Suspense
      fallback={
        <div className="h-full flex items-center justify-center text-gray-400">
          Chargement du visualiseur…
        </div>
      }
    >
      <PdfViewerImpl {...props} />
    </Suspense>
  );
}

export default PdfViewer;
